import { render, staticRenderFns } from "./vertical.vue?vue&type=template&id=7b3b4656"
import script from "./vertical.vue?vue&type=script&lang=js"
export * from "./vertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b3b4656')) {
      api.createRecord('7b3b4656', component.options)
    } else {
      api.reload('7b3b4656', component.options)
    }
    module.hot.accept("./vertical.vue?vue&type=template&id=7b3b4656", function () {
      api.rerender('7b3b4656', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layouts/vertical.vue"
export default component.exports